<template>
<v-list-item class="px-0">
  <v-skeleton-loader
      v-if="$vuetify.display.mdAndUp || index > 1"
      type="divider"
  />
  <v-row>
    <v-col
        order="3"
        order-md="1"
        cols="5"
        md="2"
        class="text-end text-md-center"
        align-self="center"
    >
      <v-skeleton-loader type="text"/>
    </v-col>
    <v-col
        order="1"
        order-md="3"
        cols="1"
        md="3"
        class="text-md-center"
        align-self="center"
    >
      <v-skeleton-loader
          v-if="$vuetify.display.mdAndUp"
          type="text"
      />
      <v-skeleton-loader
          v-else
          type="sentences"
      />
    </v-col>
    <v-col
        order="2"
        order-md="5"
        cols="6"
        md="2"
        class="text-md-center pl-5"
        align-self="center"
    >
      <v-skeleton-loader type="text"/>
    </v-col>
    <v-col
        order="4"
        order-md="7"
        md="5"
        class="pt-0 pb-4 py-md-3"
    >
      <v-skeleton-loader type="text"/>
    </v-col>
  </v-row>
</v-list-item>
</template>

<script>

export default{
  name: "PaymentListItemSkeleton",
  props: {
    index: Number
  }
}
</script>

<style scoped>

</style>